export default __webpack_public_path__ + "static/media/Resources_By_Topic.43b7f342.png";